import "../styles/Footer.scss";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="inner">
        <p>© 2025 TuraÇevre Yönetim Sistemi</p>
      </div>
    </footer>
  );
}
